export const ownerListLoading = state => state.owner.listLoading;
export const ownerListData = state => state.owner.listData;
export const ownerListFetched = state => state.owner.listFetched;

export const currentItemSelector = state => state.owner.currentItem;
export const ownerCreateOrUpdateErrorsSelector = state => state.owner.errors;
export const ownerCreateOrUpdateInProcessSelector = state => state.owner.createOrUpdateInProcess;
